import React, { useState, useCallback, useRef, useEffect } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import apiCall from "../../../../apicall";
import { useSelector } from "react-redux";
import Toast from "../../../common/toast";
import Spinner from "../../../common/spinner";
import SessionExpired from "../../../common/sessionExpired";

const mapContainerStyle = {
  width: "100%",
  height: "400px",
};

const center = {
  lat: parseFloat(process.env.REACT_APP_DEFAULT_LATITUDE),
  lng: parseFloat(process.env.REACT_APP_DEFAULT_LONGITUDE),
};

const CanAddLocationPopup = ({
  locationDetails,
  setLocationDetails,
  markerPosition,
  setMarkerPosition,
  autocompleteInput,
  setAutocompleteInput,
  isEditLocation,
  resetListFunction,
  resetLocationState,
}) => {
  const { TOKEN } = useSelector((state) => state.menu);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [autocompleteKey, setAutocompleteKey] = useState(Date.now());
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [isLoading, setIsLoading] = useState(false);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API,
    libraries: ["places"],
  });

  const [formErrors, setFormErrors] = useState({});
  const modalRef = useRef(null);

  const handleAutocompleteInputChange = (e) => {
    setAutocompleteInput(e.target.value);
  };

  const handlePlaceSelected = (place) => {
    const addressComponents = place.address_components;
    setAutocompleteInput(place.formatted_address);
    const streetNumber =
      addressComponents.find((component) =>
        component.types.includes("street_number")
      )?.long_name || "";

    const route =
      addressComponents.find((component) => component.types.includes("route"))
        ?.long_name || "";

    const sublocality =
      addressComponents.find(
        (component) =>
          component.types.includes("sublocality_level_1") ||
          component.types.includes("locality") ||
          component.types.includes("neighborhood")
      )?.long_name || "";

    const locationName = `${streetNumber} ${route}`;
    console.log("location namemmm", locationName);

    setLocationDetails({
      locationName: locationName.trim() || place.formatted_address,
      address: place.formatted_address.split(",")[0] || "",
      city:
        addressComponents.find((component) =>
          component.types.includes("locality")
        )?.short_name ||
        addressComponents.find((component) =>
          component.types.includes("neighborhood")
        )?.short_name ||
        "",
      country:
        addressComponents.find((component) =>
          component.types.includes("country")
        )?.short_name || "",
      state:
        addressComponents.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.short_name || "",
      zipcode:
        addressComponents.find((component) =>
          component.types.includes("postal_code")
        )?.long_name || "",
    });

    setSelectedPlace(place);
    setMarkerPosition({
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });
  };

  const displayErrMsg = (errMsg) => {
    setErrSuccessMsg({
      message: errMsg,
      status: false,
    });
    setIsLoading(false);
  };

  const handleInputChange = (e, fieldName) => {
    const { name, value, checked, type } = e.target;
    setLocationDetails((prevValues) => ({
      ...prevValues,
      [fieldName || name]: type === "checkbox" ? checked : value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName || name]: "",
    }));
  };

  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMarkerPosition({ lat, lng });

    try {
      const geocoder = new window.google.maps.Geocoder();
      const response = await geocoder.geocode({ location: { lat, lng } });

      if (response.results[0]) {
        handlePlaceSelected(response.results[0]);
      } else {
        displayErrMsg("No results found for the selected location.");
      }
    } catch (error) {
      displayErrMsg("Geocoding failed due to: " + error.message);
    }
  };

  const validateForm = () => {
    const errors = {};

    // Validate fields common to both roles
    if (
      !locationDetails.locationName ||
      locationDetails.locationName.trim() === ""
    ) {
      errors.locationName = "Location Name is required.";
    }
    if (locationDetails.clientLocation) {
      if (
        !locationDetails.clientName ||
        locationDetails.clientName.trim() === ""
      ) {
        errors.clientName = "Client Name is required.";
      }
    }
    console.log("Validation Errors:", errors);
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  useEffect(() => {
    if (locationDetails.locationName) {
      validateForm();
    }
  }, [locationDetails.locationName]);

  console.log("locationDetails====", locationDetails)

  //   const resetLocationState = () => {
  //     setLocationDetails({
  //       locationName: "",
  //       address: "",
  //       city: "",
  //       country: "",
  //       state: "",
  //       zipcode: "",
  //       buildingNum: "",
  //       clientName: "",
  //       clientLocation: false,
  //       locationId: "",
  //     });
  //   };

  const handleAddLocation = async () => {
    if (validateForm()) {
      let locationData;

      if (isEditLocation) {
        locationData = {
          locationName: locationDetails.locationName,
          clientName: locationDetails?.clientLocation
            ? locationDetails.clientName
            : "",
        };
      } else {
        locationData = {
          address: locationDetails.address.trim(),
          city: locationDetails.city,
          country: locationDetails.country,
          locationName: locationDetails.locationName,
          location: {
            longitude: selectedPlace.geometry.location.lng(),
            latitude: selectedPlace.geometry.location.lat(),
          },
          state: locationDetails.state,
          zipCode: locationDetails.zipcode,
          suitNumber: locationDetails.buildingNum,
          clientLocation: locationDetails.clientLocation,
          clientName: locationDetails?.clientLocation
            ? locationDetails.clientName
            : "",
        };
      }

      const url = isEditLocation
        ? `institutions/${locationDetails?.locationId}/updateLocation`
        : `institutions/locations`;
      const method = isEditLocation ? "PUT" : "POST";
      try {
        setIsLoading(true);
        const addLocationResponse = await apiCall(
          url,
          method,
          locationData,
          TOKEN
        );
        console.log("add Location response", addLocationResponse);
        if (addLocationResponse?.status === 200) {
          setIsLoading(false);
          setSessionExpired(false);
          setAutocompleteInput("");
          resetListFunction(isEditLocation ? null : true);
          setAutocompleteKey(Date.now());
          setErrSuccessMsg({
            message: `Location ${
              isEditLocation ? "Edited" : "Added"
            } Successfully!`,
            status: "Success",
          });
          resetLocationState();
          setTimeout(() => {
            if (modalRef.current) {
              modalRef.current.click();
            }
          }, 2000);
        } else if (addLocationResponse?.response?.status == 401) {
          displayErrMsg("Your session has been expired!");
          setSessionExpired(true);
        } else if (addLocationResponse?.response?.status == 400) {
          displayErrMsg(addLocationResponse?.response?.data?.errorMessage);
          setSessionExpired(false);
        } else {
          setSessionExpired(false);
          // displayErrMsg("Something went wrong!");
          displayErrMsg(addLocationResponse?.response?.data?.message);
        }
        setSelectedPlace(null);
        setMarkerPosition(null);
      } catch (err) {
        setSessionExpired(false);
        displayErrMsg("Something went wrong!");
      }
    } else {
      displayErrMsg("Check the form validation!");
    }
  };

  //   const formatAddress = (address, city, state, zipCode) => {
  //     const parts = [address, city, state, zipCode]?.filter(Boolean);
  //     return parts.join(", ");
  //   };

  //   const handleSelectedLocation = (item) => {
  //     setIsEditLocation(true);
  //     const address = formatAddress(
  //       item?.address,
  //       item?.city,
  //       item?.state,
  //       item?.zipCode
  //     );
  //     setAutocompleteInput(address);
  //     setLocationDetails({
  //       locationName: item?.locationName || "",
  //       address: item?.address || "",
  //       city: item?.city || "",
  //       country: "",
  //       state: item?.state || "",
  //       zipcode: item?.zipCode || "",
  //       buildingNum: item?.suitNumber || "",
  //       clientName: item?.clientName || "",
  //       clientLocation: item?.clientName ? true : false,
  //       locationId: item?.id,
  //     });
  //     setMarkerPosition({
  //       lat: item?.location?.latitude,
  //       lng: item?.location?.longitude,
  //     });
  //   };

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  return (
    <div
      className="modal fade twm-sign-up"
      id="add_can_location_popup"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ zIndex : "20000" }}>
          <div className="modal-header" style={{ marginBlock: "0px" }}>
            <h4 className="modal-title" id="can-location">
              {isEditLocation ? "Edit Location" : "Add Location"}
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={modalRef}
            />
          </div>
          <div className="modal-body">
            <div className="form-group">
              <GooglePlacesAutocomplete
                key={autocompleteKey}
                apiKey={process.env.REACT_APP_GOOGLE_API}
                onPlaceSelected={handlePlaceSelected}
                defaultValue={autocompleteInput}
                placeholder="Start typing address or place pin on map"
                className="form-control"
                types={["geocode"]}
                disabled={isEditLocation}
                options={{
                  types: ["address"],
                  bounds: {
                    north: parseFloat(process.env.REACT_APP_LOC_NORTH_BOUND),
                    south: parseFloat(process.env.REACT_APP_LOC_SOUTH_BOUND),
                    east: parseFloat(process.env.REACT_APP_LOC_EAST_BOUND),
                    west: parseFloat(process.env.REACT_APP_LOC_WEST_BOUND),
                  },
                  componentRestrictions: { country: ["us", "vi"] },
                }}
                inputProps={{
                  value: autocompleteInput,
                  onChange: handleAutocompleteInputChange,
                }}
              />
            </div>
            {locationDetails.address && (
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="form-group " style={{ marginTop: "30px" }}>
                  <label>Location Name</label>
                  <div className="ls-inputicon-box">
                    <input
                      className="form-control"
                      name="locationName"
                      type="text"
                      placeholder="Location Name"
                      value={locationDetails.locationName}
                      onChange={(e) => handleInputChange(e, "locationName")}
                    />
                  </div>
                  {formErrors.locationName && (
                    <span className="error-message">
                      {formErrors.locationName}
                    </span>
                  )}
                </div>
              </div>
            )}
            {locationDetails.address && (
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="form-group ">
                  <label>Suite/Unit/Building</label>
                  <div className="ls-inputicon-box">
                    <input
                      className="form-control"
                      name="buildingNum"
                      type="text"
                      placeholder="Suite/Unit/Building"
                      value={locationDetails.buildingNum}
                      onChange={(e) => handleInputChange(e, "buildingNum")}
                      disabled={isEditLocation}
                    />
                  </div>
                </div>
              </div>
            )}
            {locationDetails.address && (
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="form-group ">
                  <label className="custom-checkbox manage-team-checkbox">
                    <input
                      type="checkbox"
                      name="clientLocation"
                      checked={locationDetails?.clientLocation || false}
                      onChange={(e) => handleInputChange(e, "clientLocation")}
                    />
                    <span className="custom-checkbox-label ml-3">
                      Client Location
                    </span>
                  </label>
                </div>
              </div>
            )}
            {locationDetails?.clientLocation && (
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="form-group ">
                  <label>Client Name</label>
                  <div className="ls-inputicon-box">
                    <input
                      className="form-control"
                      name="buildingNum"
                      type="text"
                      placeholder="Client Name"
                      value={locationDetails?.clientName}
                      onChange={(e) => handleInputChange(e, "clientName")}
                    />
                  </div>
                  {formErrors.clientName && (
                    <span className="error-message">
                      {formErrors?.clientName}
                    </span>
                  )}
                </div>
              </div>
            )}
            <div style={{ height: "400px", marginTop: "10px" }}>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={12}
                center={markerPosition || center}
                onClick={isEditLocation ? undefined : handleMapClick}
              >
                {markerPosition && <Marker position={markerPosition} />}
              </GoogleMap>
            </div>
          </div>
          <div className="modal-footer">
            <button onClick={handleAddLocation} className="btn btn-success">
              {isLoading ? (
                <Spinner />
              ) : isEditLocation ? (
                "Edit Location"
              ) : (
                "Add Location"
              )}
            </button>
          </div>
        </div>
      </div>
      {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""}
      {sessionExpired && <SessionExpired />}
    </div>
  );
};

export default CanAddLocationPopup;
